/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash Generator — SHA-256, SHA-1, SHA-512 | Toolverse`)
};

const es_hg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de hash — SHA-256, SHA-1, SHA-512 | Toolverse`)
};

const de_hg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash-Generator — SHA-256, SHA-1, SHA-512 | Toolverse`)
};

const nl_hg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash-generator — SHA-256, SHA-1, SHA-512 | Toolverse`)
};

const fr_hg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de hash — SHA-256, SHA-1, SHA-512 | Toolverse`)
};

const it_hg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di Hash — SHA-256, SHA-1, SHA-512 | Toolverse`)
};

const pt_br2_hg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Hash — SHA-256, SHA-1, SHA-512 | Toolverse`)
};

const pt_hg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Hash — SHA-256, SHA-1, SHA-512 | Toolverse`)
};

const ja_hg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハッシュジェネレーター—SHA-256、SHA-1、SHA-512 | Toolverse`)
};

const zh_hg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`哈希生成器 — SHA-256、SHA-1、SHA-512 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hg_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hg_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hg_meta_title", locale)
	if (locale === "en") return en_hg_meta_title(inputs)
	if (locale === "es") return es_hg_meta_title(inputs)
	if (locale === "de") return de_hg_meta_title(inputs)
	if (locale === "nl") return nl_hg_meta_title(inputs)
	if (locale === "fr") return fr_hg_meta_title(inputs)
	if (locale === "it") return it_hg_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_hg_meta_title(inputs)
	if (locale === "pt") return pt_hg_meta_title(inputs)
	if (locale === "ja") return ja_hg_meta_title(inputs)
	return zh_hg_meta_title(inputs)
};